import { Table, Text, useToggle } from '@factorialco/deprecated-design-system'

import { ExplotableItem, ExplotableList } from 'modules/core/components/GroupingExplotable'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

interface Props {
  firstName?: string | null
  lastName?: string | null
  fullName?: string | null
  identifier?: string | null
  companyIdentifier?: string | null
}

const PersonalDataGroup = ({
  firstName,
  lastName,
  fullName,
  identifier,
  companyIdentifier,
}: Props) => {
  const [open, toggle] = useToggle(true)

  const data: [string, string | null | undefined][] = []
  if (fullName) {
    data.push([
      i18n.t('payroll_bundle.results_payments.result_upload.map_to_concepts.full_name'),
      fullName,
    ])
  } else {
    data.push([
      i18n.t('payroll_bundle.results_payments.result_upload.map_to_concepts.name'),
      firstName,
    ])
    data.push([
      i18n.t('payroll_bundle.results_payments.result_upload.map_to_concepts.last_name'),
      lastName,
    ])
  }
  data.push([
    i18n.t('payroll_bundle.results_payments.result_upload.map_to_concepts.id_number'),
    identifier,
  ])

  data.push([
    i18n.t('payroll_bundle.results_payments.result_upload.map_to_concepts.company_identifier'),
    companyIdentifier,
  ])

  const renderRow = (name: string, value: string | null | undefined) => (
    <Table.Row key={name}>
      <Table.Cell>
        <Text.Normal>{name}</Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <Text.Normal color="grey700">{value}</Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <TextField value={name} readonly></TextField>
      </Table.Cell>
    </Table.Row>
  )

  return (
    <ExplotableList>
      <ExplotableItem
        opened={open}
        selected={false}
        toggle={toggle(!open)}
        headerBorders={false}
        renderHeader={() => (
          <Text.Normal size="200" weight="medium" color="grey800">
            {i18n.t('payroll_bundle.results_payments.result_upload.map_to_concepts.personal_data')}
          </Text.Normal>
        )}
        size="small"
      >
        <Table hideBorder>{data.map(([name, value]) => renderRow(name, value))}</Table>
      </ExplotableItem>
    </ExplotableList>
  )
}

export default PersonalDataGroup
